import { cn } from "@/lib/utils";

interface HudBubbleProps {
  channelId: string;
  displayText: string;
  backgroundColor: string;
  unreadCount: number;
  firstUnreadMessageId?: string | null;
  onClick: (channelId: string, firstUnreadMessageId?: string | null) => void;
}

export function HudBubble({
  channelId,
  displayText,
  backgroundColor,
  unreadCount,
  firstUnreadMessageId,
  onClick,
}: HudBubbleProps) {
  return (
    <button
      data-testid={`chat-hud-${channelId}`}
      onClick={() => onClick(channelId, firstUnreadMessageId)}
      className={cn(
        "h-6 px-3 rounded-full text-xs font-bold text-white",
        "shadow-md cursor-pointer transition-transform hover:scale-105",
        "flex items-center gap-1.5 whitespace-nowrap"
      )}
      style={{
        backgroundColor,
        textShadow: "0 1px 2px rgba(0,0,0,0.3)",
      }}
    >
      <span className="truncate max-w-[80px]">{displayText}</span>
      {unreadCount > 1 && (
        <span className="bg-white/20 rounded-full px-1.5 text-[10px]">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
}

interface HudBubbleContainerProps {
  children: React.ReactNode;
  position?: "left" | "right";
  moreCount?: number;
}

export function HudBubbleContainer({
  children,
  position = "left",
  moreCount = 0,
}: HudBubbleContainerProps) {
  return (
    <div
      className={cn(
        "absolute -top-3 z-50 flex gap-2 pointer-events-auto items-center",
        position === "left" ? "left-6" : "right-6"
      )}
    >
      {children}
      {moreCount > 0 && (
        <span className="h-6 px-2 rounded-full text-xs font-medium text-muted-foreground bg-muted/80 backdrop-blur-sm flex items-center">
          +{moreCount}
        </span>
      )}
    </div>
  );
}
